import { InfoCircleOutlined } from '@ant-design/icons'
import { Popover, Tag } from 'antd'
import { bmiLevels, bmiScaleTable } from '../services/Bmi'

// reference table of both scales, with the row for the current BMI highlighted
const BmiScaleTable = ({ bmi }) => {
    const value = parseFloat(bmi)

    return (
        <table className="table table-sm table-bordered mb-0 text-nowrap">
            <thead>
                <tr>
                    <th>BMI</th>
                    <th>Asian scale</th>
                    <th>WHO scale</th>
                </tr>
            </thead>
            <tbody>
                {bmiScaleTable().map((row) => {
                    const isCurrent = value >= row.min && value < row.max
                    return (
                        <tr key={row.key} className={isCurrent ? 'table-warning fw-bold' : ''}>
                            <td>{row.range}</td>
                            <td><Tag color={row.asian.color}>{row.asian.label}</Tag></td>
                            <td><Tag color={row.who.color}>{row.who.label}</Tag></td>
                        </tr>
                    )
                })}
            </tbody>
        </table>
    )
}

// shows the obesity level for a BMI on both the Asian and the WHO scale
export const BmiLevelTags = ({ bmi }) => {
    const levels = bmiLevels(bmi)
    if (!levels) return null

    return (
        <span>
            <Tag color={levels.asian.color}>Asian: {levels.asian.label}</Tag>
            <Tag color={levels.who.color}>WHO: {levels.who.label}</Tag>
            <Popover
                title="Obesity level by BMI"
                trigger="click"
                content={<BmiScaleTable bmi={bmi} />}
            >
                <InfoCircleOutlined
                    className="text-secondary"
                    style={{ cursor: 'pointer' }}
                    aria-label="Show BMI scale table"
                />
            </Popover>
        </span>
    )
}
